var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MasterProposalQuote',{attrs:{"mpEntity":_vm.mpEntity,"disabled":_vm.disabled},on:{"mp-refresh":function($event){return _vm.$emit('mp-refresh');}}})}
var staticRenderFns = []

export { render, staticRenderFns }